const E = 10;
export {
  E as CROP_MINIMUM_DIMENSION_PERCENTAGE
};
